import { Model } from 'modules/core/lib/mobx-rest'

import type { IShare, ResourceTypes } from './Share'

export interface IReportShare extends IShare {
  resource_type: typeof ResourceTypes.Report
  metadata: { mode: ReportShareMode; visibility: ReportShareVisibility }
}

export const ReportShareModes = {
  /**
   * Share the report structure, but each sharee will see it only filled with the data they have access to.
   */
  Personal: 'personal',
  /**
   * Share the report structure AND the original data, as if the sharee was seeing it through the eyes of the sharer.
   */
  Become: 'become',
} as const

export type ReportShareMode = (typeof ReportShareModes)[keyof typeof ReportShareModes]

export const ReportShareVisibilities = {
  Viewer: 'viewer',
  Editor: 'editor',
} as const

export type ReportShareVisibility =
  (typeof ReportShareVisibilities)[keyof typeof ReportShareVisibilities]

export class ReportShare extends Model<IReportShare> {
  get primaryKey() {
    return 'id'
  }

  static urlRoot() {
    return '/permissions/shares'
  }

  get id() {
    return this.attributes.id
  }

  get granterId() {
    return this.attributes.granter_id
  }

  get granteeType() {
    return this.attributes.grantee_type
  }

  get granteeId() {
    return this.attributes.grantee_id
  }

  get reportId() {
    return this.attributes.resource_id
  }

  get mode() {
    return this.attributes.metadata.mode
  }

  get visibility() {
    return this.attributes.metadata.visibility
  }

  create() {
    throw new Error('Use Report.share() instead') // TODO: Maybe give both options?
  }
}
